import React from "react";
import { Div, MediumFilledButton, MediumOutlineButton } from "components/Base";
import { connect } from "react-redux";
import { actions, getters } from "../model";
import { noop } from "utils/General";
import { TAB_IDS } from "../constants";
import { getIsManageSessionsEnabled } from "Portal/NewPortal/PortalHome/selectors";
import { getFormHasChanges, getIsValid } from "../selectors";

const decorate = connect(
  state => ({
    isEditingDetails: getters.isEditingDetails(state),
    selectedTab: getters.selectedTab(state),
    isManageSessionsEnabled: getIsManageSessionsEnabled(state),
    saving: getters.saving(state),
    formHasChanges: getFormHasChanges(state),
    isValid: getIsValid(state)
  }),
  {
    setIsEditingDetails: actions.setIsEditingDetails,
    save: actions.save,
    onCancel: actions.onCancel
  }
);

const Footer = ({
  isEditingDetails = false,
  selectedTab,
  setIsEditingDetails = noop,
  closeView,
  isManageSessionsEnabled,
  formHasChanges,
  saving,
  isValid,
  save,
  onCancel
}) => {
  if (!isManageSessionsEnabled) {
    return null;
  }

  const showFooter = selectedTab === TAB_IDS.DETAILS;

  if (!showFooter) {
    return null;
  }

  return (
    <Div width={1} px={5} py={4} style={{ borderTop: "1px solid #E7E6EA;" }}>
      {selectedTab === TAB_IDS.DETAILS ? (
        !isEditingDetails ? (
          <>
            <MediumFilledButton
              onClick={() => setIsEditingDetails(true)}
              className="accentable-primary-button"
              bg="primary7"
              mr={2}
            >
              Edit
            </MediumFilledButton>
            <MediumOutlineButton onClick={closeView}>Done</MediumOutlineButton>
          </>
        ) : (
          <>
            <MediumFilledButton
              bg="primary7"
              className="accentable-primary-button"
              disabled={saving || !formHasChanges || !isValid}
              onClick={save}
            >
              {saving ? "Saving..." : "Save Changes"}
            </MediumFilledButton>
            <MediumOutlineButton ml={2} onClick={onCancel}>
              Cancel
            </MediumOutlineButton>
          </>
        )
      ) : null}

      {isValid !== true ? (
        <Div fs={1} color="gray7">
          {isValid}
        </Div>
      ) : null}
    </Div>
  );
};

export default decorate(Footer);
